import React, { JSX } from 'react';
import { Box, Heading } from '@chakra-ui/react';
import { MainPageContent, PageHeading } from 'common/components';
import { useTranslations } from 'contexts/LocalizationContext';

import DebtsTable from './components/DebtsTable';
import PaymentsTable from './components/PaymentsTable';

const ApplicationUserEcoFeePage = (): JSX.Element => {
  const t = useTranslations();
  return (
    <MainPageContent>
      <PageHeading>{t('users_eco_fee.page_title')}</PageHeading>
      <Box pb={6}>
        <Heading variant={'table'} color={'blueGrey.500'} mb={-9} pl={1}>
          {t('users_eco_fee.section_debts')}
        </Heading>
        <DebtsTable />
      </Box>
      <Box pt={6}>
        <Heading variant={'table'} color={'blueGrey.500'} pb={1} pl={1}>
          {t('users_eco_fee.section_payments')}
        </Heading>
        <PaymentsTable />
      </Box>
    </MainPageContent>
  );
};

export default ApplicationUserEcoFeePage;
